import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from "@angular/common";
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { SecurityService } from '../../../services/security/security.service';
import {
  MatPaginator, MatSort,
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
  MatTableDataSource
} from "@angular/material";
import { LoginService } from 'app/services/login/login.service';

export const MY_FORMATS = {
  parse: {
    dateInput: "LL"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY"
  }
};
@Component({
  selector: 'app-usuario-cambio',
  templateUrl: './lista-usuario.component.html',
  styleUrls: ['./lista-usuario.component.css'],
  providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class ListaUsuarioComponent implements OnInit {
  user: any;
  id_empresa: any;
  estadoFilter = new FormControl('');
  empresaFilter = new FormControl('');
  nombreFilter = new FormControl('');
  tipoCambio: any;
  abrirEditarTipoCambio: boolean;
  abrirEditarUsuario: boolean = false;
  usuario: string;
  formularioEditarUsuario: FormGroup;
  abrirListaAccesos: boolean = false;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  pageSizeOptions = [10, 20, 30, 50, 100, 200];
  users: any = [];
  loading: boolean = false;
  datas: any = [];

  displayedColumns: string[] =
    ['Checked', 'Usuario', 'Nombre', 'Email', 'Telefono', 'Estado', 'id_empresa'];

  filterValues = {
    Nombre: '',
    Estado: '',
    id_empresa: ''
  };

  dataSource = new MatTableDataSource(this.users);
  FFinal: Date = new Date();
  FInicial: Date = new Date();
  Fuente: any = '';

  constructor(private securityService: SecurityService, private activateRoute: ActivatedRoute, private loginService: LoginService, private datePipe: DatePipe, private router: Router) {

    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.id_empresa = this.user.id_empresa;
    this.activateRoute.params.subscribe(
      params => {
        this.usuario = params['id'];
        this.obtenerUsuario();
        this.abrirEditarTipoCambio = false;
      })
  }

  ngOnInit() {
    this.nombreFilter.valueChanges
      .subscribe(
        Nombre => {
          this.filterValues.Nombre = Nombre;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )

    this.estadoFilter.valueChanges
      .subscribe(
        Estado => {
          this.filterValues.Estado = Estado;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )

    this.empresaFilter.valueChanges
      .subscribe(
        id_empresa => {
          this.filterValues.id_empresa = id_empresa;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )

  }

  createFilter(): (data: any, filter: string) => boolean {
    return function (data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return data.Nombre.toLowerCase().indexOf(searchTerms.Nombre) !== -1
        && data.Estado.toString().toLowerCase().indexOf(searchTerms.Estado) !== -1
        && data.id_empresa.toString().toLowerCase().indexOf(searchTerms.id_empresa) !== -1;
    }
  }


  obtenerUsuario() {
    this.formularioEditarUsuario = new FormGroup({});
    this.loginService.listarUsuarios(this.id_empresa)
      .subscribe(res => {
        this.loading = false;
      });

  }

  cargarLstTiposDeCambio() {

    this.loading = true;

    this.loginService.listarUsuarios(this.id_empresa).subscribe(
      res => {
        this.users = res;
        this.dataSource = new MatTableDataSource(this.users);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.dataSource.filterPredicate = this.createFilter();
        this.loading = false;
      }
    );
  }

  btnVer(fila: any) {
    this.tipoCambio = fila;
    this.abrirEditarTipoCambio = true;
  }

  cerrarVentanaEditarTipoCambio() {
    this.abrirEditarTipoCambio = false;
    this.cargarLstTiposDeCambio();
  }

  editarUsuario(element: any) {
    this.loginService.clickGuard = true;
    this.loginService.dataUser = element;
    this.router.navigate(['/usuarios/editarUsuario/']);
  }

  abrirListaAcceso(element: any) {
    this.securityService.dataUser = element;
    this.abrirListaAccesos = true;

  }

  CerrarPopUpListaAcceso() {
    this.abrirListaAccesos = false;
  }

}
